import {
  ConfigurationPanel,
  ConfigurationPanelBody,
  ConfigurationPanelFooter,
  ConfigurationPanelHeader,
} from "../../Components/ConfigurationPanel";
import { Button } from "V2.0/common/button";
import useWaitForCallbackForm from "./useWaitForCallbackForm";
import WaitForCallbackForm from "./WaitForCallbackForm";

export default WaitForCallbackConfig;

function WaitForCallbackConfig(props) {
  const { node, closePanel, onSave, validationErrors } = props;

  const { formState, validate, errors, updateFormState } =
    useWaitForCallbackForm(node.data, validationErrors);

  const handleSave = () => {
    if (!validate()) return;

    onSave(node.id, {
      ...node.data,
      ...formState,
    });

    closePanel();
  };

  return (
    <ConfigurationPanel>
      <ConfigurationPanelHeader>
        <p>Configure Wait for Callback</p>
      </ConfigurationPanelHeader>
      <ConfigurationPanelBody>
        <WaitForCallbackForm
          formState={formState}
          updateFormState={updateFormState}
          errors={errors}
        />
      </ConfigurationPanelBody>
      <ConfigurationPanelFooter>
        <div className="flex justify-end gap-x-2 items-center">
          <Button
            outline
            onClick={closePanel}
          >
            Cancel
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </div>
      </ConfigurationPanelFooter>
    </ConfigurationPanel>
  );
}
